import React, { FC, useEffect, useMemo } from 'react';

import { Box } from '@mui/system';

import {
  AdminLegendVariant,
  IBookedPharmacistData,
  adminActions,
  isLoadingSelector,
} from '@pharmaplan/common';
import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';

import { setBack, setFooterShow, setTitle } from '../../../actions/drawerActions';
import DrawerOutOfDateTitle from '../../common/DrawerOutOfDateTitle';
import useOptimizedAvatar from '../../../hooks/useOptimizedAvatar';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import useAdminEvent from '../../../hooks/Admin/useAdminEvent';
import useGetItems from '../../../hooks/useGetItems';
import strings from '../../../localization';

import SingleBooking from './SingleBooking';
import useMultiShiftFilter from '../../../hooks/useMultiShiftFilter';

interface IBookingList {
  date: string;
}

const BookingList: FC<IBookingList> = ({ date }) => {
  const dispatch = useAppDispatch();
  const { adminEvents: bookingList } = useMultiShiftFilter();

  const { getAdminEventByDate } = useAdminEvent();

  const loading = useAppSelector((state) =>
    isLoadingSelector([adminActions.getAdminEvent], state));

  useEffect(() => {
    const title = (
      <DrawerOutOfDateTitle
        date={date}
        dateLabel={strings.bookedWorkshiftsFormatted}
      />
    );

    dispatch(setTitle({ title }));
    dispatch(setBack(null));

    dispatch(setFooterShow(false));
    getAdminEventByDate({
      selectedDate: date.split('T')[0],
      type: AdminLegendVariant.booked,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pharmacistIds = (bookingList as IBookedPharmacistData[]).map(
    (item) =>
      item[idStore.id as keyof typeof item] as string,
  );

  const pIds = useMemo(() =>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    pharmacistIds, [bookingList]);

  useOptimizedAvatar(pIds);
  const { getPharmacistImage } = useGetItems();

  return (
    <Box>
      {loading ? (
        <SingleBooking
          image=""
          item={bookingList?.[0] as IBookedPharmacistData}
        />
      ) : (
        (bookingList as IBookedPharmacistData[]).map((item) =>
          (
            <SingleBooking
              image={getPharmacistImage(item.pharmacistId)}
              key={item.bookingId}
              item={item}
            />
          ))
      )}
    </Box>
  );
};

export default BookingList;
